export default __webpack_public_path__ + "static/media/res-guide.bea5fbdf.JPG";